import styled from 'styled-components/native';

import { brightGrey, coral, peacock, warrior } from '../../constants/color';
import Touchable from '../../elements/Touchable';

const CONTAINER_PADDING = 12;
const CONTENT_HEIGHT = 24;
const CONTAINER_HEIGHT = CONTENT_HEIGHT + CONTAINER_PADDING * 2;

export const S = {
  Container: styled(Touchable)<{ isReachThreshold: boolean }>`
    padding: ${CONTAINER_PADDING}px 15px;
    font-size: 13px;
    line-height: 21px;
    min-height: ${CONTAINER_HEIGHT}px;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    background-color: ${({ isReachThreshold }) =>
      isReachThreshold ? `${coral}1A` : brightGrey};
  `,
  LeftSection: styled.View`
    flex-direction: row;
    align-items: center;
    flex: 1;
    flex-wrap: wrap;
  `,
  Text: styled.Text`
    margin-left: 8px;
    margin-right: 4px;
    flex: 1;
    color: ${warrior};
  `,
  FreeDeliveryMoney: styled.Text`
    color: ${peacock};
  `,
  CouponMoney: styled.Text`
    color: ${coral};
  `,
  BoldText: styled.Text`
    font-weight: bold;
  `,
  ThresholdText: styled.Text`
    margin-left: 8px;
    color: ${peacock};
  `,
  CouponWrapper: styled.View`
    transform: rotate(45deg);
  `,
};
